import { FieldsBoundaries } from 'app/containers/Map/slice/types';

/* --- STATE --- */

export interface FieldState {
  allRoutesFilters: AllRoutesFiltersType;

  tempFieldsList: ITempFieldListItem[];
  shapeFileId: string | null;
  importFieldsFromSeason: {
    loading: boolean;
    isOpen: boolean;
  };
  editForm: {
    loading: boolean;
    isOpen: boolean;
  };
  deleteFieldLoading: boolean;
  drawnFields: {
    polygonsArr: IDrawnPolygon[];
  };
  editField: {
    latlngs: PolygonLatLngType;
    fieldId: number | null;
    name: string | null;
    companyId: number | null;
    seasonId: number | null;
  };
  fieldNotes: string;
  fieldProperties: { [key: string]: string | number };
}

export type AllRoutesFiltersType = {
  startDate?: string;
  endDate?: string;
};

export interface ISetEditFieldPayload {
  fieldId?: number | null;
  name?: string | null;
  companyId?: number | null;
  seasonId?: number | null;
  latlngs: PolygonLatLngType;
}

export type PolygonLatLngType =
  | L.LatLngLiteral
  | L.LatLngLiteral[]
  | L.LatLngLiteral[][]
  | L.LatLngLiteral[][][];

export type PolygonLatLngTupleType =
  | L.LatLngTuple
  | L.LatLngTuple[]
  | L.LatLngTuple[][]
  | L.LatLngTuple[][][];

export enum fieldSubmenuEnum {
  map = 'map',
  information = 'information',
  tasks = 'tasks',
}

export interface ITempFieldResponse {
  type: string;
  features: {
    type: string;
    id: string;
    geometry: {
      type: string;
      coordinates: FieldsBoundaries;
    };
    geometry_name: string;
    properties: {
      [key: string]: unknown;
    };
  }[];
  totalFeatures: number;
  numberMatched: number;
  numberReturned: number;
  timeStamp: string;
  crs: { type: string; properties: { name: string } };
}

export interface IFieldListItemProps {
  $isSelected: boolean;
}

export interface IFieldInformation {
  [key: string]: {
    geometryInfo: {
      coordinates: FieldsBoundaries;
      type: string;
    };
    propertiesJson: string;
  };
}

export interface IConfirmFieldUploadData {
  fieldInformation: IFieldInformation;
  seasonId: number;
  shapeFileId: string;
}

export interface ITempFieldListItem {
  id: string;
  area: number;
  readableArea: string;
}

export enum editFieldDataFormEnum {
  fieldName = 'fieldName',
  companyId = 'companyId',
  notes = 'notes',
}

export interface ISubmitEditFieldDataPayload {
  envId: number;
  companyId: number;
  fieldId2: number;
  fieldName: string;
  notes: string;
}
export interface IGetFieldNotesPayload {
  envId: number;
  fieldId2: number;
}
export interface IGetFieldPropertiesPayload extends IGetFieldNotesPayload {}
export interface IGetLayerByShapeIdPayload {
  envId: number;
  shapeFileId: string;
}

export interface IUpdateFieldInformationData {
  companyId: number;
  fieldId: number;
  fieldName: string;
}

export interface IDeleteFieldPayload {
  envId: number;
  fieldId: number;
}

export interface IDrawnPolygon {
  id: string;
  latlngs: L.LatLng[];
}

export interface ISubmitNewFieldsPayload {
  [fieldId: string]: string;
}
export interface ISubmitDrawnFieldsPayload extends ISubmitNewFieldsPayload {}

export interface IUploadPolygonData {
  companyId: number;
  fieldName: string;
  geometryInfo: {
    coordinates: PolygonLatLngTupleType;

    type: string;
  };
  seasonId: number;
}

export interface ISubmitImportFieldsFromSeasonPayload {
  envId: number;
  companyId: number;
  fromSeasonId: number;
  seasonId: number;
}

export interface ISeasonForFieldImport {
  season: {
    id: number;
    year: number;
    startDate: string;
    endDate: string;
    name: string;
  };
  fieldCount: number;
}

export interface IImportFieldsFromSeasonResponse {
  uploadedFieldNames: string[];
  intersectingFields: null;
}
